import styled from 'styled-components'

const Title = styled.h1`
  display: inline-block;
  text-transform: uppercase;
  font-size: 6rem;
  padding-top: 40px;
  font-weight: bold;
  color: #99dae09e;
  letter-spacing: -.2rem;
  mix-blend-mode: multiply;
  opacity: .8;
  text-align: left;
  font-family: Arial Black, sans-serif;
  background: -webkit-linear-gradient(left, #ecf4f5 0%, #6fbabf 24%,#395154 49%,#6fbabf 100%);
  background-position: right top;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  @media (max-width: 991.98px) { font-size: 5rem; padding-top: 100px;}
  @media (max-width: 767.98px) {
    font-size: 3rem;
    padding-top: 30px;
  }
  @media (max-width: 575.98px) {
    font-size: 2.2rem;
    padding-top: 20px;
    letter-spacing:0;
  }
`
export default Title



// WEBPACK FOOTER //
// ./src/components/title.js